import http from "../../../services/httpService";
import { injectHtml } from "../../../utils/htmlUtil";
import { error, isEmpty } from "../../common/global";
import { catchError } from "../../../utils/errorUtil";
import { openDialog, dialogModel } from "../../common/dialog";

const props = {
    adminProductBulkUpdateMarker: '.marker-product-bulk-update-management',
    searchterm_selector: '#search-field',
    productstatus_selector: '#filter-product-status',
    productcategory_selector: '#filter-product-category',
    searchResultInternalWrapper: '#search-results-wrapper-internal',
    productRowParentWrapper: '.product-row-wrapper',
    productRowFullPriceElement: '.product-row-full-price',
    productRowSalePriceElement: '.product-row-sale-price',
    productRowStatusElement: '.product-row-status'
};

var lastFullPrice = 0;

export function initAdminProductBulkUpdate() {

    if ($(props.adminProductBulkUpdateMarker).length) {
        setupProductBulkUpdateSearchEvents();

        //initialise view by setting the default filter to be:

        // - status: published
        $(props.productstatus_selector).val(2);

        $(props.productstatus_selector).change();
    }
}


function setupProductBulkUpdateSearchEvents() {

    $(props.searchterm_selector).off("keypress").on('keypress', function (e) {
        if (e.which === 13) {
            e.preventDefault();

            reloadBulkUpdateSearchResults();
        }
    });

    $(props.productstatus_selector).off("change").on("change", function (e) {

        reloadBulkUpdateSearchResults();
    });

    $(props.productcategory_selector).off("change").on("change", function (e) {

        reloadBulkUpdateSearchResults();
    });

    //PURPOSE: initialises search button click event
    $('.mdc-text-field__icon').off("click").on('click', function (e) {
        reloadBulkUpdateSearchResults();
    });

}

async function reloadBulkUpdateSearchResults() {

        //attempt POST save, then check response
        const data = {

            SearchTerm: $(props.searchterm_selector).val(),
            ProductStatusId: $(props.productstatus_selector).val(),
            ProductCategoryId: $(props.productcategory_selector).val()
        };

        const result = await getBulkUpdateSearchResultsService(data);

        await injectHtml(props.searchResultInternalWrapper, result);

        setTimeout(function () {

            setupProductRowEvents();

        }, 100);        
}

function setupProductRowEvents() {

    $(props.productRowFullPriceElement).off("blur").on("blur", function() {

        //basic validation; if full price has no value (or is less than 0) do not proceed
        if (isEmpty($(this).val())) {
            alert('Full price must have a value set above 0');
        } else {
            updateSingleProductRow($(this));
        }
    });

    $(props.productRowFullPriceElement).off("keypress").on('keypress', function(e)  {

        if (e.which === 13) {
            e.preventDefault();

            //basic validation; if full price has no value (or is less than 0) do not proceed
            if (isEmpty($(this).val())) {
                alert('Full price must have a value set above 0');
            } else {
                updateSingleProductRow($(this));
            }
        }
    });

    //SALE PRICE. save on exit and when enter key is pressed.
    $(props.productRowSalePriceElement).off("blur").on("blur", function () {

        updateSingleProductRow($(this));
    });

    $(props.productRowSalePriceElement).off("keypress").on('keypress', function(e) {
        if (e.which === 13) {
            e.preventDefault();

            updateSingleProductRow($(this));
        }
    });

    //PRODUCT STATUS. save on change.
    $(props.productRowStatusElement).off("change").on("change", function () {

        updateSingleProductRow($(this));
    });
}



async function updateSingleProductRow(childElement) {

    //attempt POST save, then check response

    var parentRow = childElement.closest(props.productRowParentWrapper);

    if (parentRow.length === 0) {

        alert('parent not found');
    }

    const data = {

        Id: parentRow.data('productvariant-id'),
        FullPrice: parentRow.find(props.productRowFullPriceElement).val(),
        SalePrice: parentRow.find(props.productRowSalePriceElement).val(),
        ProductStatusTypeId: parentRow.find(props.productRowStatusElement).val()
    };

    const result = await updateProductRowService(data);

    if (result.responseType !== "SUCCESS") {

        openDialog({
            ...dialogModel,
            title: 'An error occurred',
            content: result.responseMessage,
            displayConfirm: false,
            cancelButtonText: 'Close',
            theme: 'delete'
        });
    }
    else {

        //briefly change the bg colour of the row the change was applied to in order to highlight to the user that something has changed.
        parentRow.addClass('bg-light-green');

        setTimeout(function () {

            parentRow.removeClass('bg-light-green');

        }, 1000);

    }
}

//API CALLS
async function getBulkUpdateSearchResultsService(data) {

    //no TRY CATCH as handled by parent
    const response = await http.post('/administration/productmanagement/productbulkupdatemanagementsearch', data);

    // The response is an object with a property called 'data'. This contains the HTML.
    return response.data;
}

async function updateProductRowService(data) {

    //no TRY CATCH as handled by parent
    const response = await http.post('/administration/productmanagement/updatesingleproduct', data);

    return response.data;
}